import React from "react";
import { Box, Flex, Text } from "ui-components";
import { iconThemes } from "ui-components/theme";
import isEmpty from "lodash/isEmpty";
import filter from "lodash/filter";
import map from "lodash/map";
import { useSelector } from "react-redux";
import { makeSelectThemeColors } from "ducks/selectors/appSettings";
import FormattedMessage from "components/FormattedMessage/index";

const PhoneDetailsItem = ({ items = {}, primaryColor }) => {
  const themeColors = useSelector(makeSelectThemeColors());
  const phoneItems = filter(items, { type: "phone" });
  return isEmpty(phoneItems) ? null : (
    <Box my={5}>
      {map(phoneItems, phoneItem => (
        <Flex
          py={1}
          justifyContent="space-between"
          alignItems="center"
          px={"1rem"}
        >
          <Box paddingRight={4} justifySelf="flex-start" flex={1}>
            <Text
              fontWeight={phoneItem.fontWeight || "bold"}
              py="4px"
              color={
                phoneItem.benefit ? themeColors?.success : themeColors?.text
              }
            >
              <FormattedMessage id={phoneItem.label} />
            </Text>
          </Box>
          <Box width={["fit-content"]}>
            <Text
              fontWeight={phoneItem.fontWeight || "bold"}
              py="4px"
              color={phoneItem.benefit ? themeColors?.error : primaryColor}
            >
              {phoneItem.price}
            </Text>
          </Box>
        </Flex>
      ))}
    </Box>
  );
};

PhoneDetailsItem.defaultProps = {
  items: {},
  primaryColor: iconThemes.black
};

export default PhoneDetailsItem;
